<template>
  <v-navigation-drawer v-model="internalValue" app width="260" elevation="2" :class="isDark ? 'color-bDrawDark' : 'color-bDraw'">
    <!-- ENCABEZADO AZUL -->
    <v-sheet :class="isDark ? 'color-bDrawDark' : 'color-bDraw'" class="pa-4">
      <v-img
        :src="require('@/assets/prometheus-light.png')"
        contain
        class="mx-auto mb-2"
        style="width: 100%; max-width: clamp(90px, 60%, 160px)"
      ></v-img>
      <div class="text-h6 font-weight-bold">
       <span style="font-size: 20px;">{{ $t("saludo") }}</span>  <br>
       <span style="font-size: 16px;">{{ nombre }}</span> 
       
      </div>
    </v-sheet>

    <!-- SEPARADOR -->
<div class="linea-separadora"></div>
    <!-- LISTA DE ENLACES -->
    <v-list nav density="compact" class="side-nav">
      <!-- INICIO -->
      <v-list-item :to="{ name: 'HomePag' }" class="nav-item" link>
        <template #prepend>
          <div class="nav-icon">
            <v-icon icon="mdi-home" />
          </div>
        </template>
        <v-list-item-title>{{ $t("inicio") }}</v-list-item-title>
      </v-list-item>

      <v-list-item v-if="!isAdmin" :to="{ name: 'MisUsos' }" class="nav-item" link>
        <template #prepend>
          <div class="nav-icon">
            <v-icon icon="mdi-chart-donut" />
          </div>
        </template>
        <v-list-item-title> Mi Consumo </v-list-item-title>
      </v-list-item>
      <!-- IAModels 

      <v-list-item :to="{ name: 'IAModel' }" class="nav-item" link>
        <template #prepend>
          <div class="nav-icon">
            <v-icon icon="mdi-robot" />
          </div>
        </template>
        <v-list-item-title>IAModels</v-list-item-title>
      </v-list-item>-->

      <!-- ChatGPT -->
<!-- 
      <v-list-item :to="{ name: 'ChatGPT' }" class="nav-item" link>
        <template #prepend>
          <div class="nav-icon">
            <v-img
              :src="isDark ? chatgptIcon2 : chatgptIcon"
              class="chatgpt-icon"
              contain
            />
          </div>
        </template>
        <v-list-item-title>ChatGPT</v-list-item-title>
      </v-list-item> -->
       <!-- $$Se quito para que admin no realice cosas con lo que es los modelos solo los manager, tester y owners$$ -->
      <!-- IAModels ITW -->
      <v-list-item v-if="!isAdmin" :to="{ name: 'GeneracionProyecto' }" class="nav-item" link>
        <template #prepend>
          <div class="nav-icon">
            <v-icon icon="mdi-robot" />
          </div>
        </template>
        <v-list-item-title>IAModels ITW</v-list-item-title>
      </v-list-item>

       <v-list-item  v-if="isAdmin || isManager" :to="{ name: 'UsageUnidadProyectTeam' }" class="nav-item" link>
        <template #prepend>
          <div class="nav-icon">
            <v-icon icon="mdi-monitor-dashboard " />
          </div>
        </template>

          <v-list-item-title>Dashboard Consumos</v-list-item-title>
      </v-list-item>

     

     

      <!-- Equipos ITW -->
      <!-- <v-list-item :to="{ name: 'EquiposProyecto' }" class="nav-item" link>
        <template #prepend>
          <div class="nav-icon">
            <v-icon icon="mdi-account-group" />
          </div>
        </template>
        <v-list-item-title>{{ $t("Equipos") }}</v-list-item-title>
      </v-list-item> -->

      <!-- Grupo -->
      <!-- <v-list-group class="nav-group">
        <template #activator="{ props }">
          <v-list-item v-bind="props" class="nav-item">
            <template #prepend>
              <div class="nav-icon">
                <v-icon icon="mdi-account" />
              </div>
            </template>
            <v-list-item-title>{{ $t("search") }}</v-list-item-title>
          </v-list-item>
        </template>
        <v-list-item class="nav-subitem" link>
          <v-list-item-title>{{ $t("search1") }}</v-list-item-title>
        </v-list-item>
        <v-list-item class="nav-subitem" link>
          <v-list-item-title>{{ $t("search2") }}</v-list-item-title>
        </v-list-item>
      </v-list-group> -->
      <!-- Configuracion v-slot-->  
      <v-list-group class="nav-group">
        <template #activator="{ props }">  
          <v-list-item v-bind="props" class="nav-item">
            <template #prepend>
              <div class="nav-icon">
                <v-icon icon="mdi-cog" />
              </div>
            </template>
            <v-list-item-title>{{ $t("conf") }}</v-list-item-title>
          </v-list-item>
        </template>
        <!-- Esto se elimina para admin , pero dejame revisar lo del manager -->

        <v-list-item v-if="isManager || isOwner" :to="{ name: 'EquiposProyecto' }" class="nav-subitem" link>
          <v-icon icon="mdi-account-group" />
          <v-list-item-title>Administracion Equipos</v-list-item-title>
        </v-list-item>
        <v-list-item
        v-if="isManager"
        :to="{ name: 'LimiteUsuariosUnidad' }"
        class="nav-subitem"
        link
      >
        <template #prepend>
          <div class="nav-icon">
            <v-icon icon="mdi-account-cash" />
          </div>
        </template>
        <v-list-item-title>Límites de mi Unidad</v-list-item-title>
      </v-list-item>
        <v-list-item
          v-if="isAdmin"
          :to="{ name: 'RegistroUsuario' }"
          class="nav-subitem"
          link
        >
          <v-icon icon="mdi-account-plus" />
          <v-list-item-title>Registrar Usuarios</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="isAdmin"
          :to="{ name: 'AdminRol' }"
          class="nav-subitem"
          link
        >
          <v-icon icon="mdi-account-convert-outline" />
          <v-list-item-title>Administrar Usuarios</v-list-item-title>
        </v-list-item>
        
        <v-list-item
          v-if="isAdmin"
          :to="{ name: 'AdminLimites' }"
          class="nav-subitem"
          link
        >
          <v-icon icon="mdi-currency-usd" />
          <v-list-item-title>Asignar Limites</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <!-- Unidades de Negocio (grupo propio) -->
      <v-list-group v-if="isAdmin" class="nav-group">
        <template #activator="{ props }">
          <v-list-item v-bind="props" class="nav-item">
            <template #prepend>
              <div class="nav-icon">
                <v-icon icon="mdi-office-building-outline" />
              </div>
            </template>
            <v-list-item-title>Unidades de Negocio</v-list-item-title>
          </v-list-item>
        </template>

        <v-list-item :to="{ name: 'UnidadesNegocio' }" class="nav-subitem" link>
          <v-icon icon="mdi-domain" />
          <v-list-item-title>Administracion Unidades</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ name: 'UserUnidadNegocio' }" class="nav-subitem" link>
          <v-icon icon="mdi-domain" />
          <v-list-item-title>Usuarios/Unidad de Negocio</v-list-item-title>
        </v-list-item>

        <v-list-item :to="{ name: 'LimiteUnidades' }" class="nav-subitem" link>
          <v-icon icon="mdi-currency-usd" />
          <v-list-item-title>Límites por Unidad</v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import "@/css/DashNavigator/StyleDashNavigator.css";
import chatgptIcon from "@/assets/chatgpt.png";
import chatgptIcon2 from "@/assets/chatgpt2.png";
import { useSettingsStore } from "@/stores/settings";
import { useAuthStore } from "@/stores/auth";

export default {
  name: "DashNavigatorAdmin",

  inject: ["vuetify"],
  data() {
    return {
      chatgptIcon,
      chatgptIcon2,
    };
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    nombre: {
      type: String,
      required: true,
    },
  },

  //modelValue'], // evento que voy a emitir desde mi propiedad personalizada
  computed: {
    isDark() {
      const settings = useSettingsStore();
      return settings.theme === "dark";
    },
    // Solo Admin QA ve registrar/administrar usuarios y límites (Owner no).
    // Rol reactivo desde el store (fuente = backend).
    isAdmin() {
      return useAuthStore().isAdmin;
    },
    isManager(){
      return useAuthStore().isManager;
    },
    isOwner(){
      return useAuthStore().isOwner;
    },
    //Propiedades computadas
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        // este es el valor de la propiedad False o True
        //console.log("computada ", val);
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>

<style>
.linea-separadora {
  height: 4px;              /* Grosor de la línea */
  background-color: #BD1321;
  margin: 16px 24px;        /* 16px arriba/abajo, 24px a los lados */
  border-radius: 2px;       /* Opcional: esquinas ligeramente redondeadas */
}

/* Borde rojo a la derecha SOLO en el item seleccionado */
.side-nav .v-list-item--active {
  border-left: 4px solid #BD1321;
}

.color-bDraw{
background-color: #E2E3E2;

}
.color-bDrawDark{
background-color: #161617;
}
</style>
